import api from "./client";
export async function listMedia(cursor) {
    const params = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
    const res = await api.get(`/admin/media${params}`);
    return res.data;
}
export async function deleteMedia(key) {
    await api.delete(`/admin/uploads/${encodeURIComponent(key)}`);
}
